const { COLORS } = require("../colors");
const { BASE } = require("./base");
const GREEN_THEME = {
  ...BASE,
  primary: COLORS.green["600"],
  primaryDarker: COLORS.green["800"],
  componentBackground: COLORS.green["50"],
  componentBackgroundDarker: COLORS.green["200"],
};

module.exports = {
  GREEN_THEME,
};
